import { render } from "./TechStack.vue?vue&type=template&id=4885a74c&scoped=true"
import script from "./TechStack.vue?vue&type=script&lang=js"
export * from "./TechStack.vue?vue&type=script&lang=js"

import "./TechStack.vue?vue&type=style&index=0&id=4885a74c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4885a74c"]])

export default __exports__